export const UpdateProfileActionTypes = {
  UPDATE_PROFILE_LOADING: "UPDATE_PROFILE_LOADING",
  UPDATE_PROFILE_ERROR: "UPDATE_PROFILE_ERROR",
  UPDATE_PROFILE_SUCCESS: "UPDATE_PROFILE_SUCCESS",
};
